import { message } from 'antd';
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { fetchExamCodesRequestAPI } from "../../../services/examCodes-service";
import { FETCH_EXAM_CODES, FETCH_EXAM_CODES_ERROR, FETCH_EXAM_CODES_START, FETCH_EXAM_CODES_SUCCESS } from "../../actions/receptionist/examCodesAction";

function* fetchExamCodes() {
    try {

        yield put({ type: FETCH_EXAM_CODES_START })
        const response = yield call(fetchExamCodesRequestAPI);

        if (response.success) {
            yield put({ type: FETCH_EXAM_CODES_SUCCESS, examCodes: [...response.data] })

        } else {
            message.error('Failed to fetch exam codes!');
            yield put({ type: FETCH_EXAM_CODES_ERROR, error: response.error })
        }

    } catch (error) {
        message.error('Failed to fetch exam codes!');
        yield put({ type: FETCH_EXAM_CODES_ERROR, error })

    }
}

function* fetchExamCodesWatcher() {
    yield takeLatest(FETCH_EXAM_CODES, fetchExamCodes)

}


export default function* rootSaga() {
    yield all([fetchExamCodesWatcher(),])
}